import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { setAccessToken } from './AuthStore.ts'
import axios from 'axios' 
import styles from './SignInForm.module.css'
import googleIcon from '../../assets/icons/google.svg'

const SignInForm = ({ }) => {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)

  const [formData, setFormData] = useState({
    email: '',
    password: '',
    rememberMe: false
  })

  const [showPassword, setShowPassword] = useState(false)

  useEffect(() => {
    const handlePageShow = (e) => {
      if (e.persisted || document.visibilityState === 'visible') {
        setLoading(false)
      }
    }

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        setLoading(false)
      }
    }

    window.addEventListener('pageshow', handlePageShow)
    document.addEventListener('visibilitychange', handleVisibilityChange)

    return () => {
      window.removeEventListener('pageshow', handlePageShow)
      document.removeEventListener('visibilitychange', handleVisibilityChange)
    }
  }, [])

  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }))
  }

  const togglePasswordVisibility = () => {
    setShowPassword(prev => !prev)
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (loading) return;  

    setLoading(true)

    try {
      const response = await axios.post(
        `${import.meta.env.VITE_API_BASE}/api/user/signin`,  
        {
          email: formData.email,
          password: formData.password,
        }
      )

      if (response.status === 200) {
        setAccessToken(response.data.data.accessToken)
        navigate('/dashboard') 
      } else {
        alert('로그인 실패. 다시 시도해주세요.')
      }
    } catch (error) {
      console.error('로그인 오류:', error)
      alert('로그인 중 오류가 발생했습니다.')
    } finally {
      setLoading(false)
    }
  }

  const handleSocialLogin = (provider) => {
    if (provider === 'google') {
      if (loading) return;
      setLoading(true);

      const base = (import.meta.env.VITE_APP_URL || window.location.origin)
        .replace(/\/auth\/callback\/?$/i, '')
        .replace(/\/+$/, '');

      const frontendUrl = base;


      const authUrl =
        `${import.meta.env.VITE_API_BASE}/oauth2/authorization/google?redirect_url=${encodeURIComponent(frontendUrl)}`
      window.location.href = authUrl
      return
    }
    console.log(`${provider} 로그인 (미구현)`)
  }

  return (
    <div className={styles.signInForm}>
      <div className={styles.header}>
        <h2>드로우 스토리의 시작</h2>
        <p>나의 draw&you 계정에 로그인</p>
      </div>

      <div className={styles.socialButtons}>
        <button 
          className={`${styles.socialBtn} ${styles.googleBtn}`}
          onClick={() => handleSocialLogin('google')}
        >
          <div className={styles.socialIcon}>
            <img
              src = {googleIcon}
              alt = "구글 아이콘"
            />
          </div>
          {loading ? '로그인 중…' : '구글 계정으로 로그인하기'}
        </button>
      </div>
      <div className={styles.divider}>
      </div>

      <form onSubmit={handleSubmit} className={styles.form}>
        <div className={styles.field}>
          <input
            type="email"
            placeholder="이메일"
            value={formData.email}
            onChange={(e) => handleInputChange('email', e.target.value)}
            required
          />
        </div>

        <div className={styles.field}>
          <div className={styles.passwordField}>
            <input
              type={showPassword ? 'text' : 'password'}
              placeholder="비밀번호"
              value={formData.password}
              onChange={(e) => handleInputChange('password', e.target.value)}
              required
            />
            <button
              type="button"
              className={styles.toggleBtn}
              onClick={togglePasswordVisibility}
            >
              <i className={showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'}></i>
            </button>
          </div>
        </div>

        {/*<div className={styles.options}>
          <label className={styles.checkbox}>
            <input
              type="checkbox"
              checked={formData.rememberMe}
              onChange={(e) => handleInputChange('rememberMe', e.target.checked)}
            />
            <span className={styles.checkmark}></span>
            로그인 상태 유지
          </label>
          <button type="button" className={styles.linkBtn}>
            비밀번호 찾기
          </button>
        </div>*/}

        <button type="submit" className={styles.submitBtn} disabled={loading}>
          {loading ? '로그인 중...' : '로그인'}
        </button>
      </form>

      <div className={styles.footer}>
        <span>처음이신가요?</span>
        <button className={styles.linkBtn} onClick={() => navigate('/signup')}>
          회원가입
        </button>
      </div>
    </div>
  )
}

export default SignInForm